import styled, { css } from 'styled-components';

import { Grid } from '@/components/Grid';

export const KeyFeatures = styled(Grid)`
  grid-template-columns: repeat(3, 1fr);

  ${({ theme }) => css`
    margin: ${theme.spacing(0, 0, 3)};
    row-gap: ${theme.spacing(1.5)};

    ${theme.media.md.up} {
      margin: ${theme.spacing(0, 0, 5)};
      row-gap: ${theme.spacing(2)};
      grid-template-columns: repeat(6, 1fr);
    }
  `}
`;
